const generateComponentTheme = ({borders, colors}) => {
  return {
    headerBackgroundColor: colors.contrasts.white1010,
    headerBottomBorder: `${borders.widthSmall} ${borders.style} ${colors.contrasts.grey1214}`,
    headerHeight: '4rem',
  }
}

export default generateComponentTheme
